import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { History, ChevronDown, ChevronUp, Loader2 } from 'lucide-react';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ACTION_LABELS = {
  CONSULTATION_CREATED: 'Consulta criada',
  CONSULTATION_UPDATED: 'Documento atualizado',
  CONSULTATION_APPROVED: 'Documento aprovado',
  CONSULTATION_DELETED: 'Documento excluído',
  CONSULTATION_AUTO_DELETED: 'Rascunho excluído automaticamente (retenção de 7 dias)',
  CONSULTATION_ARCHIVED: 'Registro arquivado',
  CONSULTATION_RESTORED: 'Registro restaurado',
  CONSULTATION_EXPORTED: 'PDF exportado',
  CONSULTATION_VIEWED: 'Documento visualizado',
  CONSULTATION_GENERATION_REQUESTED: 'Geração de documentação solicitada',
  CONSULTATION_GENERATED: 'Documentação gerada pela IA',
  CONSULTATION_GENERATION_FAILED: 'Falha na geração da documentação',
  DRAFT_SAVED: 'Rascunho salvo manualmente',
  DRAFT_EXPIRED: 'Rascunho expirado (retenção de 30 dias)',
  SRC_CONFIRMED: 'Síntese de raciocínio clínico confirmada',
  SRC_SAVED: 'Síntese de raciocínio clínico salva',
  ATTACHMENT_UPLOADED: 'Anexo adicionado',
  ATTACHMENT_DELETED: 'Anexo excluído',
  CREDIT_HELD: 'Crédito reservado',
  CREDIT_CONSUMED: 'Crédito consumido',
  CREDIT_RELEASED: 'Crédito liberado',
  CREDIT_REFUNDED: 'Crédito estornado',
};

const formatDateTime = (iso) => {
  try {
    return new Date(iso).toLocaleString('pt-BR', {
      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
    });
  } catch {
    return iso;
  }
};

const actorLabel = (item) =>
  item.actorUserId === 'system' ? 'Sistema' : 'Profissional';

export const AuditTrailSection = ({ consultationId }) => {
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || items !== null) return;
    const token = localStorage.getItem('token');
    setLoading(true);
    axios
      .get(`${API_URL}/audit-logs`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { entityId: consultationId, limit: 50 },
      })
      .then((res) => setItems(res.data.items || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [open, items, consultationId]);

  return (
    <div className="mt-6 bg-slate-800/50 border-slate-700 rounded-xl border" data-testid="audit-trail-section">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between p-6 text-left"
        data-testid="audit-trail-toggle"
      >
        <span className="flex items-center gap-2 text-xl font-semibold text-white">
          <History className="h-5 w-5 text-slate-400" />
          Histórico de alterações
        </span>
        {open ? <ChevronUp className="h-5 w-5 text-slate-400" /> : <ChevronDown className="h-5 w-5 text-slate-400" />}
      </button>

      {open && (
        <div className="px-6 pb-6">
          {loading ? (
            <div className="flex items-center gap-2 text-slate-400 text-sm" data-testid="audit-trail-loading">
              <Loader2 className="h-4 w-4 animate-spin" /> Carregando histórico...
            </div>
          ) : !items || items.length === 0 ? (
            <p className="text-sm text-slate-500" data-testid="audit-trail-empty">
              Nenhum evento registrado para este documento.
            </p>
          ) : (
            <ul className="space-y-3" data-testid="audit-trail-list">
              {items.map((item) => (
                <li
                  key={item.auditId}
                  className="flex items-start justify-between gap-4 border-b border-slate-700/60 pb-3 last:border-0 last:pb-0"
                  data-testid={`audit-trail-item-${item.action}`}
                >
                  <div>
                    <p className="text-sm text-slate-200">{ACTION_LABELS[item.action] || item.action}</p>
                    <p className="text-xs text-slate-500">{actorLabel(item)}</p>
                  </div>
                  <span className="text-xs text-slate-400 whitespace-nowrap">{formatDateTime(item.occurredAt)}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};
